module.exports = __webpack_public_path__ + "static/media/logo_fingo_primary_color.39b8e776.png";